import type { AddressSearchTrackingData } from '~/composables/api/usePrebookingTracking'
import * as Sentry from '@sentry/vue'

export async function trackClientSide(
  endpointPath: string,
  data: AddressSearchTrackingData | Partial<AddressSearchTrackingData>,
): Promise<void> {
  try {
    const fullUrl = `/${endpointPath}`

    await fetch(fullUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
  }
  catch (error: any) {
    Sentry.captureException(error)
  }
}
